import React from 'react';

const BarOverview = ({ language }) => {
  return (
    <section className="container pb-5">
      <h1 className="display-4 fw-bold text-black text-center">
        {language === 'am' ? 'ብሉ ኔስት ሆቴል ባር እና ሬስቶራንት' : 'Blue Nest Hotel Bar & Restaurant'}
      </h1>
      <p className="lead mt-2 text-center">
        {language === 'am' 
          ? 'በዘመናዊ ወጥ ቤታችን፣ በሙያተኛ ሰራተኞቻችን እና በተለያዩ የመመገቢያ እና የባር አገልግሎቶች ይደሰቱ።' 
          : 'Experience exceptional dining and bar services with our modern kitchen and professional staff.'}
      </p>
 <h2 className="fw-bold mb-4">
  {language === 'en' ? 'Overview' : 'አጠቃላይ እይታ'}
</h2>
      <p>
  {language === 'am'
    ? 'የብሉ ኔስት ሆቴል ባር እና ላውንጅ ለእረፍት እና ለመዝናናት ተስማሚ ቦታ ነው። ዘመናዊ አካባቢ ውስጥ የተለያዩ መጠጦች እና ቀላል መክሰሶች እናቀርባለን።'
    : "Blue Nest Hotel's Bar & Lounge provides a perfect space for relaxation and entertainment. We offer various beverages and light snacks in a modern atmosphere."}
</p>

<p>
  {language === 'am'
    ? 'በባር እና ላውንጃችን የሚገኙ፡ የሀገር ውስጥ እና ከውጭ የሚገቡ መጠጦች፣ ቀላል መክሰሶች፣ DSTV እና ዋይ-ፋይ አገልግሎት፣ ምቹ የመቀመጫ ቦታዎች፣ ዘና ያለ ድባብ።'
    : 'Our bar and lounge features: Local and imported beverages, light snacks, DSTV and Wi-Fi services, comfortable seating areas, and a relaxing atmosphere.'}
</p>

      <h4 className="mt-4">
  {language === 'am' ? 'ዋና ነጥቦች' : 'Highlights'}
</h4>

<div className="table-responsive">
  <table className="table table-bordered mt-3">
    <thead className="table-light">
      <tr>
        <th>{language === 'am' ? 'በባር እና በራሰቶራንት የሚገኙ' : 'Facility'}</th>
        <th>{language === 'am' ? 'መግለጫ' : 'Description'}</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>{language === 'am' ? 'የተሟላ ወጥ ቤታችን' : 'Kitchen'}</td>
        <td>{language === 'am' ? 'ንፁህ፣ ዘመናዊ እና በባለሙያ ሰራተኞች የተሟላ' : 'Clean, modern, fully equipped with professional staff'}</td>
      </tr>
      <tr>
        <td>{language === 'am' ? 'የምግብ' : 'Menu'}</td>
        <td>{language === 'am' ? 'ባህላዊ የኢትዮጵያ እና ዓለም አቀፍ ምግቦች' : 'Traditional Ethiopian & International cuisine'}</td>
      </tr>
      <tr>
        <td>{language === 'am' ? 'ባር' : 'Bar'}</td>
        <td>{language === 'am' ? 'የሀገር ውስጥ እና ከውጭ የሚገቡ መጠጦች፣ መክሰስ' : 'Local and imported beverages, snacks, canapés'}</td>
      </tr>
      <tr>
        <td>{language === 'am' ? 'አዝናኝ' : 'Entertainment'}</td>
        <td>{language === 'am' ? 'DSTV እና ዋይ- ፋይ  አገልግሎት፣ ዘና ያለ ድባብ' : 'DSTV service, relaxed atmosphere'}</td>
      </tr>
      <tr>
        <td>{language === 'am' ? 'መጠጥ' : 'Drinks'}</td>
        <td>{language === 'am' ? 'ከውጭ የሚገቡ መጠጦች ፣ ለስላሳ መጠጦች  እና ትኩስ' : 'Hot drinks, soft drinks, and refreshments'}</td>
      </tr>
    </tbody>
  </table>
      </div>
    </section>
  );
};

export default BarOverview;
